import { ComponentProps } from "react";
import { Portal } from "@radix-ui/react-dialog";

export const SheetPortal = ({
    ...props
}: ComponentProps<typeof Portal>) => {
    return <Portal data-slot="sheet-portal" {...props} />
}